var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"css":false,"tag":_vm.tag,"duration":{ enter: _vm.duration, leave: _vm.duration }},on:{"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }